import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { IonContent, IonSegment, IonGrid, IonRow, IonCol, IonSegmentButton, IonLabel } from '@ionic/react'

import ItemSinal from './ItemSinal';
import signalService from '../services/SignalService';
import { Sinal } from 'models/Sinal';

interface ImgItem {
  id: string,
  url: string
}

interface Props {
  selectMode?: boolean
  onSelect: (item: Sinal) => any
}


const ListSinals: React.FC<Props> = (props: Props) => {
  const location = useLocation()

  const [currentSegment, setCurrentSegment] = useState<string>('1 - 23');
  const [currentPack, setCurrentImages] = useState<ImgItem[]>([])
  const mapSignals = signalService.getSignals()

  useEffect(() => {
    setCurrentImages(mapSignals[0])
  }, [location.search, mapSignals, setCurrentImages, setCurrentSegment])

  return (
    <IonContent >
      <IonSegment className="ion-justify-content-center" scrollable={true} color="primary" value={currentSegment} onIonChange={e => setCurrentSegment(e.detail.value!)}>
        <IonSegmentButton value='1 - 23' onClick={() => setCurrentImages(mapSignals[0])}>
          <IonLabel>1 - 23</IonLabel>
        </IonSegmentButton>

        <IonSegmentButton value="24-46a" onClick={() => setCurrentImages(mapSignals[1])}>
          <IonLabel>24 - 46a</IonLabel>
        </IonSegmentButton>

        <IonSegmentButton value="c" onClick={() => setCurrentImages(mapSignals[2])}>
          <IonLabel>46b - 64</IonLabel>
        </IonSegmentButton>
      </IonSegment>

      <IonGrid fixed>
        <IonRow className="ion-justify-content-center">
          {currentPack.map((sinal, index) =>
            <IonCol size="6" size-xl="4" key={index}>
              <ItemSinal sinal={sinal} onSelect={() => props.onSelect(sinal)} />
            </IonCol>
          )}
        </IonRow>
      </IonGrid>
    </IonContent>
  )
}

export default ListSinals
